<template>
  <div>
    <h6>Automation Testing History</h6>
    <broadcast-history :get_automation="1" :get_automation_without_action="0" :allowFilterBy="true" :showAllTests="true" :edit-mode="false" :formHeader="false" :statusId="0" formTitle=""></broadcast-history>
  </div>
</template>

<script>
export default {
  components: {
    broadcastHistory: () => import('@/modules/voip-testing-panel/old-broadcast-history/page/View.vue'),
  }
}
</script>
